import { gql } from "@apollo/client";

export const CreateRenting = gql`
	mutation CreateRenting(
		$pricePerDay: Float
		$client: ID
		$machine: ID
		$startedRent: Date         
		$previsionEndingRent: Date
	) {
		createRenting(
			input: {
				pricePerDay: $pricePerDay
				client: $client
				machine: $machine
				startedRent: $startedRent   
				previsionEndingRent: $previsionEndingRent
			}
		) {
			_id
			pricePerDay
			client
			machine
			status
			startedRent           
			endedRent
			previsionEndingRent
		}
	}
`;
